import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    company_id: localStorage.getItem("company_id"),
    company_name: localStorage.getItem("company_name"),
    email: localStorage.getItem("email"),
    first_Name: localStorage.getItem("first_name"),
    last_Name: localStorage.getItem("last_name"),
    token: localStorage.getItem("satellizer_token"),
    ad_account_id: JSON.parse(localStorage.getItem("ad_account_id") || "[]"), // Array of ad_account_ids
    ad_account_name: JSON.parse(localStorage.getItem("ad_account_name") || "[]"), // Array of ad_account_names
    accounts: JSON.parse(localStorage.getItem("accounts") || "[]"), // Array of accounts
  },
  reducers: {
    loggedIn: (state, action) => {
      const { userData, model, result } = action.payload; // Ensure result is passed in the payload

      // Setting user data and company info
      state.company_id = model.company_id;
      state.token = action.payload.token;
      state.first_Name = userData.first_name;
      state.last_Name = userData.last_name;
      state.email = userData.email;
      state.company_name = userData.company_name;

      // Update ad_account_id and ad_account_name as arrays
      state.ad_account_id = result.map(account => account.account_id);
      state.ad_account_name = result.map(account => account.account_name);
      state.accounts = result; // Save full result array as accounts

      // Save to localStorage
      setUserAuth(action.payload);
    },
    loggedOut: (state) => {
      // Clear the state
      state.company_id = "";
      state.token = "";
      state.first_Name = "";
      state.last_Name = "";
      state.email = "";
      state.company_name = "";
      state.ad_account_id = [];
      state.ad_account_name = [];
      state.accounts = [];

      // Clear localStorage
      removeUserAuth();
    },
  },
});

const setUserAuth = (payload) => {
  // Store user data and auth token in localStorage
  localStorage.setItem("satellizer_token", payload.token);
  localStorage.setItem("company_id", payload.model.company_id);  // Store company ID from model
  localStorage.setItem("email", payload.userData.email);  // User email
  localStorage.setItem("first_name", payload.userData.first_name);  // First name
  localStorage.setItem("last_name", payload.userData.last_name);  // Last name
  localStorage.setItem("company_name", payload.userData.company_name);  // Company name

  // Store arrays of account ids and names in localStorage
  localStorage.setItem("ad_account_id", JSON.stringify(payload.result.map(account => account.account_id)));
  localStorage.setItem("ad_account_name", JSON.stringify(payload.result.map(account => account.account_name)));
  localStorage.setItem("accounts", JSON.stringify(payload.result));  // Store the full accounts array
};

const removeUserAuth = () => {
  // Clear localStorage
  localStorage.clear();
};

export const { loggedIn, loggedOut } = authSlice.actions;
export default authSlice.reducer;
